import React from "react";
import { Speed } from "@mui/icons-material";
import SpeedCenter from "../../../../assets/SpeedCenter";
import SpeedLeft from "../../../../assets/SpeedLeft";
import PortalTooltip from "../../../helpers/PortalTooltip";
import "./PriorityIcon.css";
import { Typography } from "@mui/material";

interface PriorityIconProps {
	color: "error" | "warning" | "success" | undefined;
	tooltip: string;
	onClick: (e: React.MouseEvent) => void;
}

const PriorityIcon = React.memo<PriorityIconProps>(({ color, tooltip, onClick }: PriorityIconProps) => {
	// Default to "warning" if color is undefined (matches viewmodel default)
	const iconColor = color ?? "warning";
	return (
		<PortalTooltip title={tooltip}>
			<div className="priority-icon-wrapper" onClick={onClick}>
				<div className={`priority-item ${iconColor === "error" ? "visible" : "hidden"}`}>
					<Typography>ASAP</Typography>
					<Speed className="priority-icon" color="error" />
				</div>
				<div className={`priority-item ${iconColor === "warning" ? "visible" : "hidden"}`}>
					<Typography>REG</Typography>
					<SpeedCenter className="priority-icon" color="warning" />
				</div>
				<div className={`priority-item ${iconColor === "success" ? "visible" : "hidden"}`}>
					<Typography>FLEX</Typography>
					<SpeedLeft className="priority-icon" color="success" />
				</div>
			</div>
		</PortalTooltip>
	);
});

PriorityIcon.displayName = "PriorityIcon";

export default PriorityIcon;
